import React from "react";
import Lottie from "lottie-react";
import animationData from "./Loading.json";

export default class LottieLoading extends React.Component {
  render() {
    const buttonStyle = {
      display: "block",
      margin: "10px auto",
    };

    const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: animationData,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice",
      },
    };

    return (
      <div>
        <Lottie
          // options={defaultOptions}
          animationData={animationData}
          className="w-full"
        />
      </div>
    );
  }
}
